import { DocsSentToPartnerFilter } from '@/types';

// Helper di normalizzazione "puri" (senza dipendenze dallo store) — vivono fuori
// da helpers/index.ts per evitare il ciclo di dipendenze
// helpers → store → modules/connections → helpers.

export default function normalizeDocsSentToPartner(v: unknown): DocsSentToPartnerFilter | null {
  if (v === 'sent' || v === 'not-sent') return v;
  if (Array.isArray(v) && v.length === 1) {
    const b = v[0];
    if (b === true || b === 'true') return 'sent';
    if (b === false || b === 'false') return 'not-sent';
  }
  return null;
}
